import React, { useEffect, useState, useCallback } from 'react'
// import localData from './data'
import { useParams } from "react-router-dom";
import YAML from "js-yaml";
import site_config_file from '../site_config.yml';
let fileType;
let hostName;
const Dashboard = () => {
    const [sideMenu, setSideMenu] = useState(null);
    const [topMenu, setTopMenu] = useState(null);
    const [filteredTopMenu, setFilteredTopMenu] = useState(null);
    const [selectedTopMenu, setSelectedTopMenu] = useState(null);
    const [menu, setMenu] = useState(null);
    const [selectedMenu, setSelectedMenu] = useState(null);
    const [dashboardData, setDashboardData] = useState(null);
    const [filteredDashboardData, setFilteredDashboardData] = useState(null)
    const [primaryColor, setPrimaryColor] = useState('#F39317');
    const [secondaryColor, setSecondaryColor] = useState("#54A601");
    const [headingColor, setHeadingColor] = useState("#000");
    const [pdfBucketName, setPdfBucketName] = useState(null);
    const params = useParams();

    useEffect(() => {
        if (sideMenu) {
            if (sideMenu[0].color1)
                setPrimaryColor(sideMenu[0].color1)
            if (sideMenu[0].color2)
                setSecondaryColor(sideMenu[0].color2)
            if (sideMenu[0].color3)
                setHeadingColor(sideMenu[0].color3)
            fetchTopMenuData(sideMenu[0].content_url)
        }
    }, [sideMenu])





    useEffect(() => {
        if (!menu) return;
        fetchDashboardData(menu[0].content_url)

        setSelectedMenu(menu[0])
    }, [menu])
    const onClickTopMenu = (tab) => {
        setSelectedTopMenu(tab);
        setMenu(tab.content.tabs)
    }

    const fetchTopMenuData = async (url) => {
        if (!url) return;

        if (fileType === 'json') {
            let res = await fetch(hostName + url);
            let json = await res.json();
            setTopMenu(json.data);
        }
        if (fileType === 'yml') {
            let res = await fetch(url);
            let data = await res.text();
            let json = YAML.load(data);
            setTopMenu(json);
        }

    }

    const fetchDashboardData = async (url) => {
        if (!url) {
            setDashboardData(null);
            return;
        }

        if (fileType === 'json') {
            let res = await fetch(hostName + url);
            let json = await res.json();

            setDashboardData(json.data);
            setPdfBucketName(json.bucket_name)

        }
        if (fileType === 'yml') {
            let res = await fetch(url);
            let data = await res.text();
            let json = YAML.load(data);
            setDashboardData(json);

        }
    }

    const handleLinkClick = async (link) => {

        if (!pdfBucketName) {
            window.open(link, "_blank")
            return;
        }
        let res
        if (fileType === 'json') {
            res = await fetch(`https://elearning.virtusasystems.com/api/pdf_explorer/get_pdf_url`, {
                // res = await fetch(`http://localhost:5001/pdf_explorer/get_pdf_url`, {

                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    bucketName: pdfBucketName,
                    key: link
                })
            })
        }
        if (res.ok) {
            const json = await res.json();
            window.open(json.url, "_blank")
        }
    }

    const fetchData = useCallback(async () => {
        if (params.code) {

            let site_config = await fetch(site_config_file);
            if (!site_config.ok) {
                return;
            }
            site_config = await site_config.text();
            site_config = YAML.load(site_config).site_config;
            let component = site_config.components.find(
                (item) => item.code === params.code
            );

            if (!component) {
                // alert("data not found");
                return;
            }

            if (component) {
                if (component.type === "json") {
                    fileType = 'json'
                    hostName = component.host_name
                    let res = await fetch(component.source_url);
                    let json = await res.json();
                    if (params.code === 'tacad-pdf-explorer-web' || params.code === 'vil-pdf-explorer-web' || params.code === 'acsl-pdf-explorer-web') {
                        let d = json.data.filter((e) => {
                            return (e.is_public === true)
                        })
                        setSideMenu(d);
                    } else {
                        setSideMenu(json.data)
                    }

                }

            }

        }
    }, [params.code]);
    useEffect(() => {
        fetchData();
        window.addEventListener("message", async (e) => {
            const { data } = e;
            if (typeof data !== "string") return;
            let { site_config_url } = await JSON.parse(data);

            if (site_config_url) {
                site_config_file = site_config_url;
                fetchData();
            } else {
                // alert("data not found");
            }
        });
    }, [fetchData]);

    useEffect(() => {

        if (params.code === 'tacad-pdf-explorer-web' || params.code === 'vil-pdf-explorer-web' || params.code === 'acsl-pdf-explorer-web') {

            let data = [];
            if (!dashboardData) return;
            dashboardData.forEach((e) => {
                if (e.is_public) {
                    let heading = e.heading;
                    let items = e.items.filter((item) => {
                        return item.is_public === true;
                    })
                    data.push({ heading, items });
                }
            })
            setFilteredDashboardData(
                data
            )
        }
        else {
            setFilteredDashboardData(dashboardData)
        }


    }, [dashboardData, params.code])


    useEffect(() => {
        if (params.code === 'tacad-pdf-explorer-web' || params.code === 'vil-pdf-explorer-web' || params.code === 'acsl-pdf-explorer-web') {
            let data = [];
            if (!topMenu) return;
            topMenu.forEach((e) => {

                if (e.is_public) {

                    let content = e.content;
                    const tabs = content.tabs.filter((item) => {
                        return item.is_public === true;
                    })
                    data.push({ ...e, content: { ...content, tabs } })
                }
            })
            setFilteredTopMenu(data)

        }
        else {
            setFilteredTopMenu(topMenu)
        }


    }, [topMenu, params.code])

    useEffect(() => {

        if (!filteredTopMenu) return;
        if (!filteredTopMenu.length) return;

        setMenu(filteredTopMenu[0].content.tabs)
        setSelectedTopMenu(filteredTopMenu[0])
    }, [filteredTopMenu])
    return (
        <>
            <div className="container-fluid p-3 " >
                {
                    sideMenu ? <>
                        <div className="d-flex  flex-row">
                            <div className="" >
                                {
                                    sideMenu && sideMenu.map((item, index) => (
                                        <h2 key={index} className=' w-100 position-sticky leftmenu-tab fs-6 p-3 px-4 text-white' onClick={() => { fetchTopMenuData(item.content_url); setPrimaryColor(item.color1); setSecondaryColor(item.color2); setHeadingColor(item.color3); setDashboardData(null) }} style={{ backgroundColor: item.color1, transition: '0.5s all' }}>{item.tab}</h2>
                                    ))
                                }
                            </div>
                            <div className=" dashboard ms-3 col bg-white">
                                <div className='d-flex mt-2'>
                                    {

                                        filteredTopMenu && filteredTopMenu.length > 0 && filteredTopMenu.map((item) => (
                                            <div key={item.tab} className='p-1 px-2  rounded mx-2 ' style={{ cursor: 'pointer', fontSize: '15px', border: `1px solid ${primaryColor}`, color: primaryColor, transition: '0.5s all' }} onClick={() => { onClickTopMenu(item) }}>{item.tab}</div>
                                        ))

                                    }

                                </div>


                                {selectedTopMenu &&

                                    <div className='mt-3 '>
                                        <h3 style={{ color: primaryColor, transition: '0.5s all' }}>{selectedTopMenu.tab}</h3>
                                        <p className='text-secondary' style={{ fontSize: '14px' }}>{selectedTopMenu.content.description}</p>

                                    </div>
                                }
                                {
                                    menu &&
                                    <div className="d-flex">
                                        {
                                            menu && menu.map((item) => (

                                                <div key={item.tab} className='p-1 px-2  rounded mx-2 ' style={{ cursor: 'pointer', fontSize: '13px', border: `1px solid ${primaryColor}`, color: primaryColor, transition: '0.5s all' }} onClick={() => { setSelectedMenu(item); fetchDashboardData(item.content_url) }}>{item.tab}</div>
                                            ))
                                        }
                                    </div>
                                }

                                <div className="row my-2 p-2 w-100" >
                                    {
                                        selectedMenu &&
                                        <div className="col-12">
                                            <h4 className='fw-semibold fs-5' style={{ color: secondaryColor, transition: '0.5s all' }} >
                                                {selectedMenu.tab}
                                            </h4>
                                        </div>
                                    }
                                    <div className='col-12'>
                                        <div className="row d-flex flex-cloumn" >
                                            {
                                                filteredDashboardData && filteredDashboardData.length > 0 && filteredDashboardData.map((content, index) => (
                                                    <div className="col-lg-3 p-2" key={index}>
                                                        {
                                                            content.link ?
                                                                <div>
                                                                    <h5 onClick={() => { handleLinkClick(content.link) }} className='fw-semibold' style={{ color: headingColor, transition: '0.5s all', fontSize: '15px', display: "inline-block", cursor: "pointer" }} onMouseOver={(e) => { e.target.style.textDecoration = "underline" }} onMouseOut={(e) => { e.target.style.textDecoration = 'none' }}>
                                                                        {content.heading}
                                                                    </h5></div> : <div> <h5 className='fw-semibold' style={{ display: "inline-block", transition: '0.5s all', fontSize: '15px' }}>
                                                                        {content.heading}

                                                                    </h5>
                                                                </div>
                                                        }
                                                        {
                                                            content.items.map((item, index) => (
                                                                <div key={index}>
                                                                    {

                                                                        item.link ?
                                                                            <div>
                                                                                <p key={index} style={{ fontSize: '13px', cursor: 'pointer', display: "inline-block" }}
                                                                                    onClick={() => { handleLinkClick(item.link) }}
                                                                                    onMouseOver={(e) => { e.target.style.textDecoration = "underline" }} onMouseOut={(e) => { e.target.style.textDecoration = 'none' }}
                                                                                    className='m-0 p-0'><span className='fw-semibold me-2'>{item.index}</span>{item.text}</p></div> : <div> <p key={index} style={{ fontSize: '13px', display: "inline-block", cursor: 'pointer' }}
                                                                                        className='m-0 p-0'><span className='fw-semibold me-2'>{item.index}</span>{item.text}</p></div>
                                                                    }

                                                                    {
                                                                        item.items && item.items.map((item) => (
                                                                            <>
                                                                                {
                                                                                    item.link ?
                                                                                        <p key={index} style={{ fontSize: '13px', cursor: 'pointer' }}
                                                                                            onClick={() => { handleLinkClick(item.link) }}
                                                                                            onMouseOver={(e) => { e.target.style.textDecoration = "underline" }} onMouseOut={(e) => { e.target.style.textDecoration = 'none' }}
                                                                                            className='m-0 ps-2'><span
                                                                                                className='fw-semibold me-2'>{item.index}</span>{item.text}</p>
                                                                                        :
                                                                                        <p key={index} style={{ fontSize: '13px', cursor: 'pointer' }}
                                                                                            className='m-0 ps-2'><span className='fw-semibold me-2'>{item.index}</span>{item.text}</p>
                                                                                }
                                                                            </>
                                                                        ))
                                                                    }


                                                                </div>


                                                            ))
                                                        }
                                                    </div>
                                                ))
                                            }
                                        </div>

                                    </div>




                                </div>

                            </div>
                        </div>

                    </>
                        : <>
                            data not found
                        </>
                }
            </div >

        </>
    )

}
export default Dashboard;
